module.exports = __webpack_public_path__ + "img/7.1b9a288b.webp";